import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@lohi/environments/environment';
import { NGXLogger } from 'ngx-logger';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { map, shareReplay, throttleTime } from 'rxjs/operators';
import { Region } from '../types';

@Injectable({
  providedIn: 'root',
})
export class RegionService {
  private regions$$ = new BehaviorSubject<Region[]>([]);
  private regionsThrottle$$ = new Subject();
  private regionsShared$ = this.regions$$.pipe(
    shareReplay(1),
    map((v) => v.sort((a, b) => a.name.localeCompare(b.name))),
  );

  public get regions$(): Observable<Region[]> {
    this.regionsThrottle$$.next();
    return this.regionsShared$;
  }

  constructor(private httpClient: HttpClient, private logger: NGXLogger) {
    this.regionsThrottle$$.pipe(throttleTime(1000)).subscribe(() => {
      this.loadRegions();
    });
  }

  private loadRegions() {
    this.httpClient.get<{ loHiRegions: Region[] }>(`${environment.api}/v2/admin/regions`).subscribe(
      (resp) => {
        this.regions$$.next(resp.loHiRegions);
      },
      (error) => {
        this.logger.error(error);
      },
    );
  }
}
